import { breakpointQueries as e } from "../breakpoints.js";
import { useMediaQuery as t } from "./use-media-query.js";
import { useEffect as n, useRef as r } from "react";
//#region src/shared/hooks/use-adaptive-overlay.ts
function i(i, a) {
	let o = t(e.isMobile, { initializeWithValue: !1 }), s = r(void 0);
	return n(() => {
		let t = window.matchMedia(e.isMobile).matches;
		s.current === void 0 && (s.current = t), o === t && s.current !== o && (s.current = o, i && a?.(!1));
	}, [
		o,
		i,
		a
	]), o;
}
//#endregion
export { i as useAdaptiveOverlay };
